import React, {PureComponent} from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal,
} from 'reactstrap';
import TrendingDownIcon from 'mdi-react/TrendingDownIcon';
import axios from "axios";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

var url = window.location.hostname;
var port = window.location.port;

class BinConsolidationCandidatesDetail extends PureComponent{
  
  state = {
    dataset : []
  }
  
  
  DetailSummary = () => {
    const payload = {
      "location": this.getCookie('selectedLocation'),
        "report_type": "BinConsolidation",
        "report_detailed" : ""
    };
    
    API.post('/reports/dashboardStaticCount/v1/', { param: payload })
    // axios('http://'+url+'/reports/dashboardStaticCount/v1/',
    // {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //   },
    //   data:{
    //     "location": this.getCookie('selectedLocation'),
    //     "report_type": "BinConsolidation",
    //     "report_detailed" : ""
    //   }
    // })
    .then((response) => {
		this.setState({
		dataset:response.data.data
		})
		
    })
  }
  
  
   getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }
  
  
  
  componentDidMount(){
    if (port == 8091) {
      port = ":8090"
    }else{
      port = ":8088"
    }
	 if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }
	  
    this.DetailSummary();
  }
  
  
render(){
	
	 const BinConsolidationData = {

      columns: [

       
        {

          label:'LBSKUID',
		  field:'LBSKUID'

        },


        {

          label:'Description',
		  field:'Description'

        },

        

        {

          label:'CBUCode',
		  field:'CBUCode'

        },

        {

          label:'BasepackCode',
          field:'BasepackCode',


        },

        {

          label:'PKD',
          field:'PKD',

        },

        {

          label:'Bin Count',
		  field:'Shade'

        },
		
		{

          label:'Total Bin Capacity (pcs)',
		  field:'TotalBinCapacity'

        },
		{

          label:'Total Current Qty',
		  field:'TotalCurrentQty'

        },
		{

          label:'Max Bin Capacity (cft)',
		  field:'MaxBinCapacity'

        },
		{

          label:'Bin Address',
		  field:'BinAddress'

        },


        
      ],

      rows:this.state.dataset,

    }




    return (
	
	<Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Bin Consolidation Candidates</h3>
      </Col>
    </Row>
   
    <Row>
      <Col xl={12}>
    <Card>
	<CardBody>
	<div className="table_val">
            <MDBDataTable
                striped
                bordered
                hover
                data={BinConsolidationData}
                sorting={true}
                paging = {true}
              />
            </div>
	</CardBody>
	</Card>
	</Col>
    </Row>

    
  </Container>
	
  );
  }
}

export default BinConsolidationCandidatesDetail;
